/* eslint-disable */
// @ts-nocheck
// THIS FILE IS GENERATED, DO NOT EDIT
// Regenerate the file by running 'yarn compile:ajv'
'use strict';
import { fullFormats } from 'ajv-formats/dist/formats';
const formatWrapper = { ...fullFormats };
function ucs2length(str) {
    const len = str.length;
    let length = 0;
    let pos = 0;
    let value;
    while (pos < len) {
        length++;
        value = str.charCodeAt(pos++);
        if (value >= 0xd800 && value <= 0xdbff && pos < len) {
            value = str.charCodeAt(pos);
            if ((value & 0xfc00) === 0xdc00)
                pos++;
        }
    }
    return length;
}
function padString(input) {
    var segmentLength = 4;
    var stringLength = input.length;
    var diff = stringLength % segmentLength;
    if (!diff) {
        return input;
    }
    var position = stringLength;
    var padLength = segmentLength - diff;
    var paddedStringLength = stringLength + padLength;
    var buffer = Buffer.alloc(paddedStringLength);
    buffer.write(input);
    while (padLength--) {
        buffer.write('=', position++);
    }
    return buffer.toString();
}
function toBase64(base64url) {
    base64url = base64url.toString();
    return padString(base64url).replace(/\-/g, '+').replace(/_/g, '/');
}
function base64urlToBuffer(base64url) {
    return Buffer.from(toBase64(base64url), 'base64');
}
function fromBase64(base64) {
    return base64.replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
}
function base64urlEncode(input, encoding) {
    if (encoding === void 0) {
        encoding = 'utf8';
    }
    if (Buffer.isBuffer(input)) {
        return fromBase64(input.toString('base64'));
    }
    return fromBase64(Buffer.from(input, encoding).toString('base64'));
}
export const columnSchemaValidation = validate12;
const schema29 = {
    $id: 'urn:wisepipe-common-data:Column',
    type: 'object',
    properties: {
        name: { type: 'string', minLength: 1, maxLength: 150 },
        type: { type: 'string', pattern: 'number|date|string|boolean|decimal|period' },
        metadata: {
            type: 'object',
            oneOf: [
                {
                    if: { properties: { type: { const: 'period' } } },
                    then: { $ref: 'urn:wisepipe-common-data:PeriodColumnMetadata' }
                },
                {
                    if: { properties: { type: { const: 'string' } } },
                    then: { $ref: 'urn:wisepipe-common-data:PicklistColumnMetadata' }
                }
            ]
        },
        isPrimaryKey: { type: 'boolean' }
    },
    required: ['name', 'type'],
    allOf: [
        {
            if: { properties: { type: { const: 'period' } } },
            then: {
                required: ['metadata'],
                properties: { metadata: { $ref: 'urn:wisepipe-common-data:PeriodColumnMetadata' } }
            }
        },
        {
            if: { properties: { type: { const: 'string' } } },
            then: { properties: { metadata: { $ref: 'urn:wisepipe-common-data:PicklistColumnMetadata' } } }
        },
        {
            if: { properties: { type: { enum: ['boolean', 'number', 'decimal', 'date'] } } },
            then: { not: { required: ['metadata'] } }
        }
    ]
};
const schema30 = {
    $id: 'urn:wisepipe-common-data:PeriodColumnMetadata',
    type: 'object',
    properties: { calendarID: { type: 'string', minLength: 1 }, level: { type: 'string', minLength: 1 } },
    required: ['calendarID', 'level']
};
const schema31 = {
    $id: 'urn:wisepipe-common-data:PicklistColumnMetadata',
    type: 'object',
    properties: { table: { type: 'string', minLength: 1 }, column: { type: 'string', minLength: 1 } },
    required: ['table', 'column']
};
const func2 = ucs2length;
const pattern0 = new RegExp('number|date|string|boolean|decimal|period', 'u');
function validate12(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:Column" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    const _errs2 = errors;
    let valid1 = true;
    const _errs3 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.type !== undefined) {
            if ('period' !== data.type) {
                const err0 = {};
                if (vErrors === null) {
                    vErrors = [err0];
                }
                else {
                    vErrors.push(err0);
                }
                errors++;
            }
        }
    }
    var _valid0 = _errs3 === errors;
    errors = _errs2;
    if (vErrors !== null) {
        if (_errs2) {
            vErrors.length = _errs2;
        }
        else {
            vErrors = null;
        }
    }
    if (_valid0) {
        const _errs5 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.metadata === undefined && (missing0 = 'metadata')) {
                validate12.errors = [
                    {
                        instancePath,
                        schemaPath: '#/allOf/0/then/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.metadata !== undefined) {
                    let data1 = data.metadata;
                    const _errs7 = errors;
                    if (errors === _errs7) {
                        if (data1 && typeof data1 == 'object' && !Array.isArray(data1)) {
                            let missing1;
                            if ((data1.calendarID === undefined && (missing1 = 'calendarID')) ||
                                (data1.level === undefined && (missing1 = 'level'))) {
                                validate12.errors = [
                                    {
                                        instancePath: instancePath + '/metadata',
                                        schemaPath: 'urn:wisepipe-common-data:PeriodColumnMetadata/required',
                                        keyword: 'required',
                                        params: { missingProperty: missing1 },
                                        message: "must have required property '" + missing1 + "'"
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data1.calendarID !== undefined) {
                                    let data2 = data1.calendarID;
                                    const _errs9 = errors;
                                    if (errors === _errs9) {
                                        if (typeof data2 === 'string') {
                                            if (func2(data2) < 1) {
                                                validate12.errors = [
                                                    {
                                                        instancePath: instancePath + '/metadata/calendarID',
                                                        schemaPath: 'urn:wisepipe-common-data:PeriodColumnMetadata/properties/calendarID/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate12.errors = [
                                                {
                                                    instancePath: instancePath + '/metadata/calendarID',
                                                    schemaPath: 'urn:wisepipe-common-data:PeriodColumnMetadata/properties/calendarID/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid5 = _errs9 === errors;
                                }
                                else {
                                    var valid5 = true;
                                }
                                if (valid5) {
                                    if (data1.level !== undefined) {
                                        let data3 = data1.level;
                                        const _errs11 = errors;
                                        if (errors === _errs11) {
                                            if (typeof data3 === 'string') {
                                                if (func2(data3) < 1) {
                                                    validate12.errors = [
                                                        {
                                                            instancePath: instancePath + '/metadata/level',
                                                            schemaPath: 'urn:wisepipe-common-data:PeriodColumnMetadata/properties/level/minLength',
                                                            keyword: 'minLength',
                                                            params: { limit: 1 },
                                                            message: 'must NOT have fewer than 1 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate12.errors = [
                                                    {
                                                        instancePath: instancePath + '/metadata/level',
                                                        schemaPath: 'urn:wisepipe-common-data:PeriodColumnMetadata/properties/level/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid5 = _errs11 === errors;
                                    }
                                    else {
                                        var valid5 = true;
                                    }
                                }
                            }
                        }
                        else {
                            validate12.errors = [
                                {
                                    instancePath: instancePath + '/metadata',
                                    schemaPath: 'urn:wisepipe-common-data:PeriodColumnMetadata/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
        }
        var _valid0 = _errs5 === errors;
        valid1 = _valid0;
    }
    if (!valid1) {
        const err1 = {
            instancePath,
            schemaPath: '#/allOf/0/if',
            keyword: 'if',
            params: { failingKeyword: 'then' },
            message: 'must match "then" schema'
        };
        if (vErrors === null) {
            vErrors = [err1];
        }
        else {
            vErrors.push(err1);
        }
        errors++;
        validate12.errors = vErrors;
        return false;
    }
    var valid0 = _errs1 === errors;
    if (valid0) {
        const _errs13 = errors;
        const _errs14 = errors;
        let valid6 = true;
        const _errs15 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.type !== undefined) {
                if ('string' !== data.type) {
                    const err2 = {};
                    if (vErrors === null) {
                        vErrors = [err2];
                    }
                    else {
                        vErrors.push(err2);
                    }
                    errors++;
                }
            }
        }
        var _valid1 = _errs15 === errors;
        errors = _errs14;
        if (vErrors !== null) {
            if (_errs14) {
                vErrors.length = _errs14;
            }
            else {
                vErrors = null;
            }
        }
        if (_valid1) {
            const _errs17 = errors;
            if (data && typeof data == 'object' && !Array.isArray(data)) {
                if (data.metadata !== undefined) {
                    let data5 = data.metadata;
                    const _errs19 = errors;
                    if (errors === _errs19) {
                        if (data5 && typeof data5 == 'object' && !Array.isArray(data5)) {
                            let missing2;
                            if ((data5.table === undefined && (missing2 = 'table')) ||
                                (data5.column === undefined && (missing2 = 'column'))) {
                                validate12.errors = [
                                    {
                                        instancePath: instancePath + '/metadata',
                                        schemaPath: 'urn:wisepipe-common-data:PicklistColumnMetadata/required',
                                        keyword: 'required',
                                        params: { missingProperty: missing2 },
                                        message: "must have required property '" + missing2 + "'"
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (data5.table !== undefined) {
                                    let data6 = data5.table;
                                    const _errs21 = errors;
                                    if (errors === _errs21) {
                                        if (typeof data6 === 'string') {
                                            if (func2(data6) < 1) {
                                                validate12.errors = [
                                                    {
                                                        instancePath: instancePath + '/metadata/table',
                                                        schemaPath: 'urn:wisepipe-common-data:PicklistColumnMetadata/properties/table/minLength',
                                                        keyword: 'minLength',
                                                        params: { limit: 1 },
                                                        message: 'must NOT have fewer than 1 characters'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate12.errors = [
                                                {
                                                    instancePath: instancePath + '/metadata/table',
                                                    schemaPath: 'urn:wisepipe-common-data:PicklistColumnMetadata/properties/table/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid10 = _errs21 === errors;
                                }
                                else {
                                    var valid10 = true;
                                }
                                if (valid10) {
                                    if (data5.column !== undefined) {
                                        let data7 = data5.column;
                                        const _errs23 = errors;
                                        if (errors === _errs23) {
                                            if (typeof data7 === 'string') {
                                                if (func2(data7) < 1) {
                                                    validate12.errors = [
                                                        {
                                                            instancePath: instancePath + '/metadata/column',
                                                            schemaPath: 'urn:wisepipe-common-data:PicklistColumnMetadata/properties/column/minLength',
                                                            keyword: 'minLength',
                                                            params: { limit: 1 },
                                                            message: 'must NOT have fewer than 1 characters'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            else {
                                                validate12.errors = [
                                                    {
                                                        instancePath: instancePath + '/metadata/column',
                                                        schemaPath: 'urn:wisepipe-common-data:PicklistColumnMetadata/properties/column/type',
                                                        keyword: 'type',
                                                        params: { type: 'string' },
                                                        message: 'must be string'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid10 = _errs23 === errors;
                                    }
                                    else {
                                        var valid10 = true;
                                    }
                                }
                            }
                        }
                        else {
                            validate12.errors = [
                                {
                                    instancePath: instancePath + '/metadata',
                                    schemaPath: 'urn:wisepipe-common-data:PicklistColumnMetadata/type',
                                    keyword: 'type',
                                    params: { type: 'object' },
                                    message: 'must be object'
                                }
                            ];
                            return false;
                        }
                    }
                }
            }
            var _valid1 = _errs17 === errors;
            valid6 = _valid1;
        }
        if (!valid6) {
            const err3 = {
                instancePath,
                schemaPath: '#/allOf/1/if',
                keyword: 'if',
                params: { failingKeyword: 'then' },
                message: 'must match "then" schema'
            };
            if (vErrors === null) {
                vErrors = [err3];
            }
            else {
                vErrors.push(err3);
            }
            errors++;
            validate12.errors = vErrors;
            return false;
        }
        var valid0 = _errs13 === errors;
        if (valid0) {
            const _errs25 = errors;
            const _errs26 = errors;
            let valid11 = true;
            const _errs27 = errors;
            if (data && typeof data == 'object' && !Array.isArray(data)) {
                if (data.type !== undefined) {
                    let data8 = data.type;
                    if (!(data8 === 'boolean' || data8 === 'number' || data8 === 'decimal' || data8 === 'date')) {
                        const err4 = {};
                        if (vErrors === null) {
                            vErrors = [err4];
                        }
                        else {
                            vErrors.push(err4);
                        }
                        errors++;
                    }
                }
            }
            var _valid2 = _errs27 === errors;
            errors = _errs26;
            if (vErrors !== null) {
                if (_errs26) {
                    vErrors.length = _errs26;
                }
                else {
                    vErrors = null;
                }
            }
            if (_valid2) {
                const _errs29 = errors;
                const _errs30 = errors;
                const _errs31 = errors;
                if (data && typeof data == 'object' && !Array.isArray(data)) {
                    let missing3;
                    if (data.metadata === undefined && (missing3 = 'metadata')) {
                        const err5 = {};
                        if (vErrors === null) {
                            vErrors = [err5];
                        }
                        else {
                            vErrors.push(err5);
                        }
                        errors++;
                    }
                }
                var valid13 = _errs31 === errors;
                if (valid13) {
                    validate12.errors = [
                        { instancePath, schemaPath: '#/allOf/2/then/not', keyword: 'not', params: {}, message: 'must NOT be valid' }
                    ];
                    return false;
                }
                else {
                    errors = _errs30;
                    if (vErrors !== null) {
                        if (_errs30) {
                            vErrors.length = _errs30;
                        }
                        else {
                            vErrors = null;
                        }
                    }
                }
                var _valid2 = _errs29 === errors;
                valid11 = _valid2;
            }
            if (!valid11) {
                const err6 = {
                    instancePath,
                    schemaPath: '#/allOf/2/if',
                    keyword: 'if',
                    params: { failingKeyword: 'then' },
                    message: 'must match "then" schema'
                };
                if (vErrors === null) {
                    vErrors = [err6];
                }
                else {
                    vErrors.push(err6);
                }
                errors++;
                validate12.errors = vErrors;
                return false;
            }
            var valid0 = _errs25 === errors;
        }
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing4;
            if ((data.name === undefined && (missing4 = 'name')) || (data.type === undefined && (missing4 = 'type'))) {
                validate12.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing4 },
                        message: "must have required property '" + missing4 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.name !== undefined) {
                    let data9 = data.name;
                    const _errs32 = errors;
                    if (errors === _errs32) {
                        if (typeof data9 === 'string') {
                            if (func2(data9) > 150) {
                                validate12.errors = [
                                    {
                                        instancePath: instancePath + '/name',
                                        schemaPath: '#/properties/name/maxLength',
                                        keyword: 'maxLength',
                                        params: { limit: 150 },
                                        message: 'must NOT have more than 150 characters'
                                    }
                                ];
                                return false;
                            }
                            else {
                                if (func2(data9) < 1) {
                                    validate12.errors = [
                                        {
                                            instancePath: instancePath + '/name',
                                            schemaPath: '#/properties/name/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                        }
                        else {
                            validate12.errors = [
                                {
                                    instancePath: instancePath + '/name',
                                    schemaPath: '#/properties/name/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid14 = _errs32 === errors;
                }
                else {
                    var valid14 = true;
                }
                if (valid14) {
                    if (data.type !== undefined) {
                        let data10 = data.type;
                        const _errs34 = errors;
                        if (errors === _errs34) {
                            if (typeof data10 === 'string') {
                                if (!pattern0.test(data10)) {
                                    validate12.errors = [
                                        {
                                            instancePath: instancePath + '/type',
                                            schemaPath: '#/properties/type/pattern',
                                            keyword: 'pattern',
                                            params: { pattern: 'number|date|string|boolean|decimal|period' },
                                            message: 'must match pattern "' + 'number|date|string|boolean|decimal|period' + '"'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate12.errors = [
                                    {
                                        instancePath: instancePath + '/type',
                                        schemaPath: '#/properties/type/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid14 = _errs34 === errors;
                    }
                    else {
                        var valid14 = true;
                    }
                    if (valid14) {
                        if (data.metadata !== undefined) {
                            let data11 = data.metadata;
                            const _errs36 = errors;
                            if (!(data11 && typeof data11 == 'object' && !Array.isArray(data11))) {
                                validate12.errors = [
                                    {
                                        instancePath: instancePath + '/metadata',
                                        schemaPath: '#/properties/metadata/type',
                                        keyword: 'type',
                                        params: { type: 'object' },
                                        message: 'must be object'
                                    }
                                ];
                                return false;
                            }
                            const _errs38 = errors;
                            let valid15 = false;
                            let passing0 = null;
                            const _errs39 = errors;
                            const _errs40 = errors;
                            let valid16 = true;
                            const _errs41 = errors;
                            if (data11 && typeof data11 == 'object' && !Array.isArray(data11)) {
                                if (data11.type !== undefined) {
                                    if ('period' !== data11.type) {
                                        const err7 = {};
                                        if (vErrors === null) {
                                            vErrors = [err7];
                                        }
                                        else {
                                            vErrors.push(err7);
                                        }
                                        errors++;
                                    }
                                }
                            }
                            var _valid4 = _errs41 === errors;
                            errors = _errs40;
                            if (vErrors !== null) {
                                if (_errs40) {
                                    vErrors.length = _errs40;
                                }
                                else {
                                    vErrors = null;
                                }
                            }
                            if (_valid4) {
                                const _errs43 = errors;
                                const _errs44 = errors;
                                if (errors === _errs44) {
                                    if (data11 && typeof data11 == 'object' && !Array.isArray(data11)) {
                                        let missing5;
                                        if ((data11.calendarID === undefined && (missing5 = 'calendarID')) ||
                                            (data11.level === undefined && (missing5 = 'level'))) {
                                            const err8 = {
                                                instancePath: instancePath + '/metadata',
                                                schemaPath: 'urn:wisepipe-common-data:PeriodColumnMetadata/required',
                                                keyword: 'required',
                                                params: { missingProperty: missing5 },
                                                message: "must have required property '" + missing5 + "'"
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err8];
                                            }
                                            else {
                                                vErrors.push(err8);
                                            }
                                            errors++;
                                        }
                                        else {
                                            if (data11.calendarID !== undefined) {
                                                let data13 = data11.calendarID;
                                                const _errs46 = errors;
                                                if (errors === _errs46) {
                                                    if (typeof data13 === 'string') {
                                                        if (func2(data13) < 1) {
                                                            const err9 = {
                                                                instancePath: instancePath + '/metadata/calendarID',
                                                                schemaPath: 'urn:wisepipe-common-data:PeriodColumnMetadata/properties/calendarID/minLength',
                                                                keyword: 'minLength',
                                                                params: { limit: 1 },
                                                                message: 'must NOT have fewer than 1 characters'
                                                            };
                                                            if (vErrors === null) {
                                                                vErrors = [err9];
                                                            }
                                                            else {
                                                                vErrors.push(err9);
                                                            }
                                                            errors++;
                                                        }
                                                    }
                                                    else {
                                                        const err10 = {
                                                            instancePath: instancePath + '/metadata/calendarID',
                                                            schemaPath: 'urn:wisepipe-common-data:PeriodColumnMetadata/properties/calendarID/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        };
                                                        if (vErrors === null) {
                                                            vErrors = [err10];
                                                        }
                                                        else {
                                                            vErrors.push(err10);
                                                        }
                                                        errors++;
                                                    }
                                                }
                                                var valid19 = _errs46 === errors;
                                            }
                                            else {
                                                var valid19 = true;
                                            }
                                            if (valid19) {
                                                if (data11.level !== undefined) {
                                                    let data14 = data11.level;
                                                    const _errs48 = errors;
                                                    if (errors === _errs48) {
                                                        if (typeof data14 === 'string') {
                                                            if (func2(data14) < 1) {
                                                                const err11 = {
                                                                    instancePath: instancePath + '/metadata/level',
                                                                    schemaPath: 'urn:wisepipe-common-data:PeriodColumnMetadata/properties/level/minLength',
                                                                    keyword: 'minLength',
                                                                    params: { limit: 1 },
                                                                    message: 'must NOT have fewer than 1 characters'
                                                                };
                                                                if (vErrors === null) {
                                                                    vErrors = [err11];
                                                                }
                                                                else {
                                                                    vErrors.push(err11);
                                                                }
                                                                errors++;
                                                            }
                                                        }
                                                        else {
                                                            const err12 = {
                                                                instancePath: instancePath + '/metadata/level',
                                                                schemaPath: 'urn:wisepipe-common-data:PeriodColumnMetadata/properties/level/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            };
                                                            if (vErrors === null) {
                                                                vErrors = [err12];
                                                            }
                                                            else {
                                                                vErrors.push(err12);
                                                            }
                                                            errors++;
                                                        }
                                                    }
                                                    var valid19 = _errs48 === errors;
                                                }
                                                else {
                                                    var valid19 = true;
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        const err13 = {
                                            instancePath: instancePath + '/metadata',
                                            schemaPath: 'urn:wisepipe-common-data:PeriodColumnMetadata/type',
                                            keyword: 'type',
                                            params: { type: 'object' },
                                            message: 'must be object'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err13];
                                        }
                                        else {
                                            vErrors.push(err13);
                                        }
                                        errors++;
                                    }
                                }
                                var _valid4 = _errs43 === errors;
                                valid16 = _valid4;
                            }
                            if (!valid16) {
                                const err14 = {
                                    instancePath: instancePath + '/metadata',
                                    schemaPath: '#/properties/metadata/oneOf/0/if',
                                    keyword: 'if',
                                    params: { failingKeyword: 'then' },
                                    message: 'must match "then" schema'
                                };
                                if (vErrors === null) {
                                    vErrors = [err14];
                                }
                                else {
                                    vErrors.push(err14);
                                }
                                errors++;
                            }
                            var _valid3 = _errs39 === errors;
                            if (_valid3) {
                                valid15 = true;
                                passing0 = 0;
                            }
                            const _errs50 = errors;
                            const _errs51 = errors;
                            let valid20 = true;
                            const _errs52 = errors;
                            if (data11 && typeof data11 == 'object' && !Array.isArray(data11)) {
                                if (data11.type !== undefined) {
                                    if ('string' !== data11.type) {
                                        const err15 = {};
                                        if (vErrors === null) {
                                            vErrors = [err15];
                                        }
                                        else {
                                            vErrors.push(err15);
                                        }
                                        errors++;
                                    }
                                }
                            }
                            var _valid5 = _errs52 === errors;
                            errors = _errs51;
                            if (vErrors !== null) {
                                if (_errs51) {
                                    vErrors.length = _errs51;
                                }
                                else {
                                    vErrors = null;
                                }
                            }
                            if (_valid5) {
                                const _errs54 = errors;
                                const _errs55 = errors;
                                if (errors === _errs55) {
                                    if (data11 && typeof data11 == 'object' && !Array.isArray(data11)) {
                                        let missing6;
                                        if ((data11.table === undefined && (missing6 = 'table')) ||
                                            (data11.column === undefined && (missing6 = 'column'))) {
                                            const err16 = {
                                                instancePath: instancePath + '/metadata',
                                                schemaPath: 'urn:wisepipe-common-data:PicklistColumnMetadata/required',
                                                keyword: 'required',
                                                params: { missingProperty: missing6 },
                                                message: "must have required property '" + missing6 + "'"
                                            };
                                            if (vErrors === null) {
                                                vErrors = [err16];
                                            }
                                            else {
                                                vErrors.push(err16);
                                            }
                                            errors++;
                                        }
                                        else {
                                            if (data11.table !== undefined) {
                                                let data16 = data11.table;
                                                const _errs57 = errors;
                                                if (errors === _errs57) {
                                                    if (typeof data16 === 'string') {
                                                        if (func2(data16) < 1) {
                                                            const err17 = {
                                                                instancePath: instancePath + '/metadata/table',
                                                                schemaPath: 'urn:wisepipe-common-data:PicklistColumnMetadata/properties/table/minLength',
                                                                keyword: 'minLength',
                                                                params: { limit: 1 },
                                                                message: 'must NOT have fewer than 1 characters'
                                                            };
                                                            if (vErrors === null) {
                                                                vErrors = [err17];
                                                            }
                                                            else {
                                                                vErrors.push(err17);
                                                            }
                                                            errors++;
                                                        }
                                                    }
                                                    else {
                                                        const err18 = {
                                                            instancePath: instancePath + '/metadata/table',
                                                            schemaPath: 'urn:wisepipe-common-data:PicklistColumnMetadata/properties/table/type',
                                                            keyword: 'type',
                                                            params: { type: 'string' },
                                                            message: 'must be string'
                                                        };
                                                        if (vErrors === null) {
                                                            vErrors = [err18];
                                                        }
                                                        else {
                                                            vErrors.push(err18);
                                                        }
                                                        errors++;
                                                    }
                                                }
                                                var valid23 = _errs57 === errors;
                                            }
                                            else {
                                                var valid23 = true;
                                            }
                                            if (valid23) {
                                                if (data11.column !== undefined) {
                                                    let data17 = data11.column;
                                                    const _errs59 = errors;
                                                    if (errors === _errs59) {
                                                        if (typeof data17 === 'string') {
                                                            if (func2(data17) < 1) {
                                                                const err19 = {
                                                                    instancePath: instancePath + '/metadata/column',
                                                                    schemaPath: 'urn:wisepipe-common-data:PicklistColumnMetadata/properties/column/minLength',
                                                                    keyword: 'minLength',
                                                                    params: { limit: 1 },
                                                                    message: 'must NOT have fewer than 1 characters'
                                                                };
                                                                if (vErrors === null) {
                                                                    vErrors = [err19];
                                                                }
                                                                else {
                                                                    vErrors.push(err19);
                                                                }
                                                                errors++;
                                                            }
                                                        }
                                                        else {
                                                            const err20 = {
                                                                instancePath: instancePath + '/metadata/column',
                                                                schemaPath: 'urn:wisepipe-common-data:PicklistColumnMetadata/properties/column/type',
                                                                keyword: 'type',
                                                                params: { type: 'string' },
                                                                message: 'must be string'
                                                            };
                                                            if (vErrors === null) {
                                                                vErrors = [err20];
                                                            }
                                                            else {
                                                                vErrors.push(err20);
                                                            }
                                                            errors++;
                                                        }
                                                    }
                                                    var valid23 = _errs59 === errors;
                                                }
                                                else {
                                                    var valid23 = true;
                                                }
                                            }
                                        }
                                    }
                                    else {
                                        const err21 = {
                                            instancePath: instancePath + '/metadata',
                                            schemaPath: 'urn:wisepipe-common-data:PicklistColumnMetadata/type',
                                            keyword: 'type',
                                            params: { type: 'object' },
                                            message: 'must be object'
                                        };
                                        if (vErrors === null) {
                                            vErrors = [err21];
                                        }
                                        else {
                                            vErrors.push(err21);
                                        }
                                        errors++;
                                    }
                                }
                                var _valid5 = _errs54 === errors;
                                valid20 = _valid5;
                            }
                            if (!valid20) {
                                const err22 = {
                                    instancePath: instancePath + '/metadata',
                                    schemaPath: '#/properties/metadata/oneOf/1/if',
                                    keyword: 'if',
                                    params: { failingKeyword: 'then' },
                                    message: 'must match "then" schema'
                                };
                                if (vErrors === null) {
                                    vErrors = [err22];
                                }
                                else {
                                    vErrors.push(err22);
                                }
                                errors++;
                            }
                            var _valid3 = _errs50 === errors;
                            if (_valid3 && valid15) {
                                valid15 = false;
                                passing0 = [passing0, 1];
                            }
                            else {
                                if (_valid3) {
                                    valid15 = true;
                                    passing0 = 1;
                                }
                            }
                            if (!valid15) {
                                const err23 = {
                                    instancePath: instancePath + '/metadata',
                                    schemaPath: '#/properties/metadata/oneOf',
                                    keyword: 'oneOf',
                                    params: { passingSchemas: passing0 },
                                    message: 'must match exactly one schema in oneOf'
                                };
                                if (vErrors === null) {
                                    vErrors = [err23];
                                }
                                else {
                                    vErrors.push(err23);
                                }
                                errors++;
                                validate12.errors = vErrors;
                                return false;
                            }
                            else {
                                errors = _errs38;
                                if (vErrors !== null) {
                                    if (_errs38) {
                                        vErrors.length = _errs38;
                                    }
                                    else {
                                        vErrors = null;
                                    }
                                }
                            }
                            var valid14 = _errs36 === errors;
                        }
                        else {
                            var valid14 = true;
                        }
                        if (valid14) {
                            if (data.isPrimaryKey !== undefined) {
                                const _errs61 = errors;
                                if (typeof data.isPrimaryKey !== 'boolean') {
                                    validate12.errors = [
                                        {
                                            instancePath: instancePath + '/isPrimaryKey',
                                            schemaPath: '#/properties/isPrimaryKey/type',
                                            keyword: 'type',
                                            params: { type: 'boolean' },
                                            message: 'must be boolean'
                                        }
                                    ];
                                    return false;
                                }
                                var valid14 = _errs61 === errors;
                            }
                            else {
                                var valid14 = true;
                            }
                        }
                    }
                }
            }
        }
        else {
            validate12.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate12.errors = vErrors;
    return errors === 0;
}
export const dataSchemaValidation = validate13;
const schema34 = {
    $id: 'urn:wisepipe-base-computation:Data',
    type: 'object',
    properties: {
        status: { type: 'string', enum: ['running', 'completed', 'failed'] },
        progress: { type: 'number', minimum: 0, maximum: 1 },
        columns: { type: 'array', items: { $ref: 'urn:wisepipe-common-data:Column' } },
        rows: { type: 'array', items: { type: 'array', items: { type: ['boolean', 'string', 'number', 'null'] } } },
        continuationToken: { type: 'string', uid: 9 },
        schema: { type: 'array', items: { $ref: 'urn:wisepipe-common-data:Column' } },
        maxNumBins: { type: 'number' },
        metrics: { type: 'array', items: { type: 'object' } }
    },
    required: ['status', 'progress'],
    if: { properties: { progress: { type: 'number', exclusiveMaximum: 1 } } },
    then: { required: ['continuationToken'] }
};
const func12 = ucs2length;
const func13 = base64urlToBuffer;
const func14 = base64urlEncode;
const func15 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
function validate13(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-base-computation:Data" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    let valid0 = true;
    const _errs2 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.progress !== undefined) {
            let data0 = data.progress;
            const _errs3 = errors;
            if (errors === _errs3) {
                if (typeof data0 == 'number') {
                    if (data0 >= 1 || isNaN(data0)) {
                        const err0 = {};
                        if (vErrors === null) {
                            vErrors = [err0];
                        }
                        else {
                            vErrors.push(err0);
                        }
                        errors++;
                    }
                }
                else {
                    const err1 = {};
                    if (vErrors === null) {
                        vErrors = [err1];
                    }
                    else {
                        vErrors.push(err1);
                    }
                    errors++;
                }
            }
        }
    }
    var _valid0 = _errs2 === errors;
    errors = _errs1;
    if (vErrors !== null) {
        if (_errs1) {
            vErrors.length = _errs1;
        }
        else {
            vErrors = null;
        }
    }
    if (_valid0) {
        const _errs5 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if (data.continuationToken === undefined && (missing0 = 'continuationToken')) {
                validate13.errors = [
                    {
                        instancePath,
                        schemaPath: '#/then/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
        }
        var _valid0 = _errs5 === errors;
        valid0 = _valid0;
    }
    if (!valid0) {
        const err2 = {
            instancePath,
            schemaPath: '#/if',
            keyword: 'if',
            params: { failingKeyword: 'then' },
            message: 'must match "then" schema'
        };
        if (vErrors === null) {
            vErrors = [err2];
        }
        else {
            vErrors.push(err2);
        }
        errors++;
        validate13.errors = vErrors;
        return false;
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing1;
            if ((data.status === undefined && (missing1 = 'status')) ||
                (data.progress === undefined && (missing1 = 'progress'))) {
                validate13.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing1 },
                        message: "must have required property '" + missing1 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.status !== undefined) {
                    let data1 = data.status;
                    const _errs6 = errors;
                    if (typeof data1 !== 'string') {
                        validate13.errors = [
                            {
                                instancePath: instancePath + '/status',
                                schemaPath: '#/properties/status/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                    if (!(data1 === 'running' || data1 === 'completed' || data1 === 'failed')) {
                        validate13.errors = [
                            {
                                instancePath: instancePath + '/status',
                                schemaPath: '#/properties/status/enum',
                                keyword: 'enum',
                                params: { allowedValues: schema34.properties.status.enum },
                                message: 'must be equal to one of the allowed values'
                            }
                        ];
                        return false;
                    }
                    var valid2 = _errs6 === errors;
                }
                else {
                    var valid2 = true;
                }
                if (valid2) {
                    if (data.progress !== undefined) {
                        let data2 = data.progress;
                        const _errs8 = errors;
                        if (errors === _errs8) {
                            if (typeof data2 == 'number') {
                                if (data2 > 1 || isNaN(data2)) {
                                    validate13.errors = [
                                        {
                                            instancePath: instancePath + '/progress',
                                            schemaPath: '#/properties/progress/maximum',
                                            keyword: 'maximum',
                                            params: { comparison: '<=', limit: 1 },
                                            message: 'must be <= 1'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (data2 < 0 || isNaN(data2)) {
                                        validate13.errors = [
                                            {
                                                instancePath: instancePath + '/progress',
                                                schemaPath: '#/properties/progress/minimum',
                                                keyword: 'minimum',
                                                params: { comparison: '>=', limit: 0 },
                                                message: 'must be >= 0'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            else {
                                validate13.errors = [
                                    {
                                        instancePath: instancePath + '/progress',
                                        schemaPath: '#/properties/progress/type',
                                        keyword: 'type',
                                        params: { type: 'number' },
                                        message: 'must be number'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid2 = _errs8 === errors;
                    }
                    else {
                        var valid2 = true;
                    }
                    if (valid2) {
                        if (data.columns !== undefined) {
                            let data3 = data.columns;
                            const _errs10 = errors;
                            if (errors === _errs10) {
                                if (Array.isArray(data3)) {
                                    var valid3 = true;
                                    const len0 = data3.length;
                                    for (let i0 = 0; i0 < len0; i0++) {
                                        const _errs12 = errors;
                                        if (!validate12(data3[i0], {
                                            instancePath: instancePath + '/columns/' + i0,
                                            parentData: data3,
                                            parentDataProperty: i0,
                                            rootData
                                        })) {
                                            vErrors = vErrors === null ? validate12.errors : vErrors.concat(validate12.errors);
                                            errors = vErrors.length;
                                        }
                                        var valid3 = _errs12 === errors;
                                        if (!valid3) {
                                            break;
                                        }
                                    }
                                }
                                else {
                                    validate13.errors = [
                                        {
                                            instancePath: instancePath + '/columns',
                                            schemaPath: '#/properties/columns/type',
                                            keyword: 'type',
                                            params: { type: 'array' },
                                            message: 'must be array'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            var valid2 = _errs10 === errors;
                        }
                        else {
                            var valid2 = true;
                        }
                        if (valid2) {
                            if (data.rows !== undefined) {
                                let data5 = data.rows;
                                const _errs13 = errors;
                                if (errors === _errs13) {
                                    if (Array.isArray(data5)) {
                                        var valid4 = true;
                                        const len1 = data5.length;
                                        for (let i1 = 0; i1 < len1; i1++) {
                                            let data6 = data5[i1];
                                            const _errs15 = errors;
                                            if (errors === _errs15) {
                                                if (Array.isArray(data6)) {
                                                    var valid5 = true;
                                                    const len2 = data6.length;
                                                    for (let i2 = 0; i2 < len2; i2++) {
                                                        let data7 = data6[i2];
                                                        const _errs17 = errors;
                                                        if (typeof data7 !== 'boolean' &&
                                                            typeof data7 !== 'string' &&
                                                            !(typeof data7 == 'number') &&
                                                            data7 !== null) {
                                                            validate13.errors = [
                                                                {
                                                                    instancePath: instancePath + '/rows/' + i1 + '/' + i2,
                                                                    schemaPath: '#/properties/rows/items/items/type',
                                                                    keyword: 'type',
                                                                    params: { type: schema34.properties.rows.items.items.type },
                                                                    message: 'must be boolean,string,number,null'
                                                                }
                                                            ];
                                                            return false;
                                                        }
                                                        var valid5 = _errs17 === errors;
                                                        if (!valid5) {
                                                            break;
                                                        }
                                                    }
                                                }
                                                else {
                                                    validate13.errors = [
                                                        {
                                                            instancePath: instancePath + '/rows/' + i1,
                                                            schemaPath: '#/properties/rows/items/type',
                                                            keyword: 'type',
                                                            params: { type: 'array' },
                                                            message: 'must be array'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                            }
                                            var valid4 = _errs15 === errors;
                                            if (!valid4) {
                                                break;
                                            }
                                        }
                                    }
                                    else {
                                        validate13.errors = [
                                            {
                                                instancePath: instancePath + '/rows',
                                                schemaPath: '#/properties/rows/type',
                                                keyword: 'type',
                                                params: { type: 'array' },
                                                message: 'must be array'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                                var valid2 = _errs13 === errors;
                            }
                            else {
                                var valid2 = true;
                            }
                            if (valid2) {
                                if (data.continuationToken !== undefined) {
                                    let data8 = data.continuationToken;
                                    const _errs19 = errors;
                                    if (errors === _errs19) {
                                        if (typeof data8 === 'string') {
                                            const b64min0 = Math.ceil((4 * 9) / 3);
                                            const b64max0 = Math.ceil((4 * 9) / 3) + 3;
                                            if (func12(data8) < b64min0 || func12(data8) > b64max0) {
                                                validate13.errors = [
                                                    {
                                                        instancePath: instancePath + '/continuationToken',
                                                        schemaPath: '#/properties/continuationToken/uid',
                                                        keyword: 'uid',
                                                        params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func12(data8) },
                                                        message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func12(data8)
                                                    }
                                                ];
                                                return false;
                                            }
                                            else {
                                                const decoded0 = func13(data8);
                                                if (decoded0.length !== 9) {
                                                    validate13.errors = [
                                                        {
                                                            instancePath: instancePath + '/continuationToken',
                                                            schemaPath: '#/properties/continuationToken/uid',
                                                            keyword: 'uid',
                                                            params: { error: 'decoded' },
                                                            message: 'must decode to 9 bytes'
                                                        }
                                                    ];
                                                    return false;
                                                }
                                                else {
                                                    const encoded0 = func14(decoded0);
                                                    if (func15(encoded0) !== func15(data8)) {
                                                        validate13.errors = [
                                                            {
                                                                instancePath: instancePath + '/continuationToken',
                                                                schemaPath: '#/properties/continuationToken/uid',
                                                                keyword: 'uid',
                                                                params: { error: 'ambiguous' },
                                                                message: 'encoding is ambiguous'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            validate13.errors = [
                                                {
                                                    instancePath: instancePath + '/continuationToken',
                                                    schemaPath: '#/properties/continuationToken/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                    var valid2 = _errs19 === errors;
                                }
                                else {
                                    var valid2 = true;
                                }
                                if (valid2) {
                                    if (data.schema !== undefined) {
                                        let data9 = data.schema;
                                        const _errs21 = errors;
                                        if (errors === _errs21) {
                                            if (Array.isArray(data9)) {
                                                var valid7 = true;
                                                const len3 = data9.length;
                                                for (let i3 = 0; i3 < len3; i3++) {
                                                    const _errs23 = errors;
                                                    if (!validate12(data9[i3], {
                                                        instancePath: instancePath + '/schema/' + i3,
                                                        parentData: data9,
                                                        parentDataProperty: i3,
                                                        rootData
                                                    })) {
                                                        vErrors = vErrors === null ? validate12.errors : vErrors.concat(validate12.errors);
                                                        errors = vErrors.length;
                                                    }
                                                    var valid7 = _errs23 === errors;
                                                    if (!valid7) {
                                                        break;
                                                    }
                                                }
                                            }
                                            else {
                                                validate13.errors = [
                                                    {
                                                        instancePath: instancePath + '/schema',
                                                        schemaPath: '#/properties/schema/type',
                                                        keyword: 'type',
                                                        params: { type: 'array' },
                                                        message: 'must be array'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        var valid2 = _errs21 === errors;
                                    }
                                    else {
                                        var valid2 = true;
                                    }
                                    if (valid2) {
                                        if (data.maxNumBins !== undefined) {
                                            const _errs24 = errors;
                                            if (!(typeof data.maxNumBins == 'number')) {
                                                validate13.errors = [
                                                    {
                                                        instancePath: instancePath + '/maxNumBins',
                                                        schemaPath: '#/properties/maxNumBins/type',
                                                        keyword: 'type',
                                                        params: { type: 'number' },
                                                        message: 'must be number'
                                                    }
                                                ];
                                                return false;
                                            }
                                            var valid2 = _errs24 === errors;
                                        }
                                        else {
                                            var valid2 = true;
                                        }
                                        if (valid2) {
                                            if (data.metrics !== undefined) {
                                                let data12 = data.metrics;
                                                const _errs26 = errors;
                                                if (errors === _errs26) {
                                                    if (Array.isArray(data12)) {
                                                        var valid8 = true;
                                                        const len4 = data12.length;
                                                        for (let i4 = 0; i4 < len4; i4++) {
                                                            let data13 = data12[i4];
                                                            const _errs28 = errors;
                                                            if (!(data13 && typeof data13 == 'object' && !Array.isArray(data13))) {
                                                                validate13.errors = [
                                                                    {
                                                                        instancePath: instancePath + '/metrics/' + i4,
                                                                        schemaPath: '#/properties/metrics/items/type',
                                                                        keyword: 'type',
                                                                        params: { type: 'object' },
                                                                        message: 'must be object'
                                                                    }
                                                                ];
                                                                return false;
                                                            }
                                                            var valid8 = _errs28 === errors;
                                                            if (!valid8) {
                                                                break;
                                                            }
                                                        }
                                                    }
                                                    else {
                                                        validate13.errors = [
                                                            {
                                                                instancePath: instancePath + '/metrics',
                                                                schemaPath: '#/properties/metrics/type',
                                                                keyword: 'type',
                                                                params: { type: 'array' },
                                                                message: 'must be array'
                                                            }
                                                        ];
                                                        return false;
                                                    }
                                                }
                                                var valid2 = _errs26 === errors;
                                            }
                                            else {
                                                var valid2 = true;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate13.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate13.errors = vErrors;
    return errors === 0;
}
export const metricSchemaValidation = validate16;
const schema35 = {
    $id: 'urn:wisepipe-base-computation:Metric',
    type: 'object',
    properties: {
        elementID: { type: 'string', uid: 10 },
        name: { type: 'string', minLength: 1, maxLength: 100 },
        type: { type: 'string', enum: ['number', 'string', 'boolean'] },
        timestamp: { type: 'string', format: 'date-time' },
        reason: { type: 'string' }
    },
    if: { properties: { type: { const: 'number' } } },
    then: { properties: { value: { type: 'number' } } },
    else: {
        if: { properties: { type: { const: 'string' } } },
        then: { properties: { value: { type: 'string' } } },
        else: { if: { properties: { type: { const: 'boolean' } } }, then: { properties: { value: { type: 'boolean' } } } }
    },
    required: ['elementID', 'name', 'type', 'value', 'timestamp']
};
const func16 = ucs2length;
const func17 = base64urlToBuffer;
const func18 = base64urlEncode;
const func19 = function trimEquals(id) {
    let end = id.length - 1;
    while (end >= 0) {
        if (id[end] !== '=')
            break;
        --end;
    }
    return id.substring(0, end + 1);
};
const formats0 = formatWrapper['date-time'];
function validate16(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-base-computation:Metric" */ let vErrors = null;
    let errors = 0;
    const _errs1 = errors;
    let valid0 = true;
    const _errs2 = errors;
    if (data && typeof data == 'object' && !Array.isArray(data)) {
        if (data.type !== undefined) {
            if ('number' !== data.type) {
                const err0 = {};
                if (vErrors === null) {
                    vErrors = [err0];
                }
                else {
                    vErrors.push(err0);
                }
                errors++;
            }
        }
    }
    var _valid0 = _errs2 === errors;
    errors = _errs1;
    if (vErrors !== null) {
        if (_errs1) {
            vErrors.length = _errs1;
        }
        else {
            vErrors = null;
        }
    }
    let ifClause0;
    if (_valid0) {
        const _errs4 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.value !== undefined) {
                if (!(typeof data.value == 'number')) {
                    validate16.errors = [
                        {
                            instancePath: instancePath + '/value',
                            schemaPath: '#/then/properties/value/type',
                            keyword: 'type',
                            params: { type: 'number' },
                            message: 'must be number'
                        }
                    ];
                    return false;
                }
            }
        }
        var _valid0 = _errs4 === errors;
        valid0 = _valid0;
        ifClause0 = 'then';
    }
    else {
        const _errs7 = errors;
        const _errs8 = errors;
        let valid3 = true;
        const _errs9 = errors;
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            if (data.type !== undefined) {
                if ('string' !== data.type) {
                    const err1 = {};
                    if (vErrors === null) {
                        vErrors = [err1];
                    }
                    else {
                        vErrors.push(err1);
                    }
                    errors++;
                }
            }
        }
        var _valid1 = _errs9 === errors;
        errors = _errs8;
        if (vErrors !== null) {
            if (_errs8) {
                vErrors.length = _errs8;
            }
            else {
                vErrors = null;
            }
        }
        let ifClause1;
        if (_valid1) {
            const _errs11 = errors;
            if (data && typeof data == 'object' && !Array.isArray(data)) {
                if (data.value !== undefined) {
                    if (typeof data.value !== 'string') {
                        validate16.errors = [
                            {
                                instancePath: instancePath + '/value',
                                schemaPath: '#/else/then/properties/value/type',
                                keyword: 'type',
                                params: { type: 'string' },
                                message: 'must be string'
                            }
                        ];
                        return false;
                    }
                }
            }
            var _valid1 = _errs11 === errors;
            valid3 = _valid1;
            ifClause1 = 'then';
        }
        else {
            const _errs14 = errors;
            const _errs15 = errors;
            let valid6 = true;
            const _errs16 = errors;
            if (data && typeof data == 'object' && !Array.isArray(data)) {
                if (data.type !== undefined) {
                    if ('boolean' !== data.type) {
                        const err2 = {};
                        if (vErrors === null) {
                            vErrors = [err2];
                        }
                        else {
                            vErrors.push(err2);
                        }
                        errors++;
                    }
                }
            }
            var _valid2 = _errs16 === errors;
            errors = _errs15;
            if (vErrors !== null) {
                if (_errs15) {
                    vErrors.length = _errs15;
                }
                else {
                    vErrors = null;
                }
            }
            if (_valid2) {
                const _errs18 = errors;
                if (data && typeof data == 'object' && !Array.isArray(data)) {
                    if (data.value !== undefined) {
                        if (typeof data.value !== 'boolean') {
                            validate16.errors = [
                                {
                                    instancePath: instancePath + '/value',
                                    schemaPath: '#/else/else/then/properties/value/type',
                                    keyword: 'type',
                                    params: { type: 'boolean' },
                                    message: 'must be boolean'
                                }
                            ];
                            return false;
                        }
                    }
                }
                var _valid2 = _errs18 === errors;
                valid6 = _valid2;
            }
            if (!valid6) {
                const err3 = {
                    instancePath,
                    schemaPath: '#/else/else/if',
                    keyword: 'if',
                    params: { failingKeyword: 'then' },
                    message: 'must match "then" schema'
                };
                if (vErrors === null) {
                    vErrors = [err3];
                }
                else {
                    vErrors.push(err3);
                }
                errors++;
                validate16.errors = vErrors;
                return false;
            }
            var _valid1 = _errs14 === errors;
            valid3 = _valid1;
            ifClause1 = 'else';
        }
        if (!valid3) {
            const err4 = {
                instancePath,
                schemaPath: '#/else/if',
                keyword: 'if',
                params: { failingKeyword: ifClause1 },
                message: 'must match "' + ifClause1 + '" schema'
            };
            if (vErrors === null) {
                vErrors = [err4];
            }
            else {
                vErrors.push(err4);
            }
            errors++;
            validate16.errors = vErrors;
            return false;
        }
        var _valid0 = _errs7 === errors;
        valid0 = _valid0;
        ifClause0 = 'else';
    }
    if (!valid0) {
        const err5 = {
            instancePath,
            schemaPath: '#/if',
            keyword: 'if',
            params: { failingKeyword: ifClause0 },
            message: 'must match "' + ifClause0 + '" schema'
        };
        if (vErrors === null) {
            vErrors = [err5];
        }
        else {
            vErrors.push(err5);
        }
        errors++;
        validate16.errors = vErrors;
        return false;
    }
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.elementID === undefined && (missing0 = 'elementID')) ||
                (data.name === undefined && (missing0 = 'name')) ||
                (data.type === undefined && (missing0 = 'type')) ||
                (data.value === undefined && (missing0 = 'value')) ||
                (data.timestamp === undefined && (missing0 = 'timestamp'))) {
                validate16.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.elementID !== undefined) {
                    let data6 = data.elementID;
                    const _errs21 = errors;
                    if (errors === _errs21) {
                        if (typeof data6 === 'string') {
                            const b64min0 = Math.ceil((4 * 10) / 3);
                            const b64max0 = Math.ceil((4 * 10) / 3) + 3;
                            if (func16(data6) < b64min0 || func16(data6) > b64max0) {
                                validate16.errors = [
                                    {
                                        instancePath: instancePath + '/elementID',
                                        schemaPath: '#/properties/elementID/uid',
                                        keyword: 'uid',
                                        params: { error: 'encoded', b64min: b64min0, b64max: b64max0, length: func16(data6) },
                                        message: 'length must be between ' + b64min0 + ' and ' + b64max0 + ', but is ' + func16(data6)
                                    }
                                ];
                                return false;
                            }
                            else {
                                const decoded0 = func17(data6);
                                if (decoded0.length !== 10) {
                                    validate16.errors = [
                                        {
                                            instancePath: instancePath + '/elementID',
                                            schemaPath: '#/properties/elementID/uid',
                                            keyword: 'uid',
                                            params: { error: 'decoded' },
                                            message: 'must decode to 10 bytes'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    const encoded0 = func18(decoded0);
                                    if (func19(encoded0) !== func19(data6)) {
                                        validate16.errors = [
                                            {
                                                instancePath: instancePath + '/elementID',
                                                schemaPath: '#/properties/elementID/uid',
                                                keyword: 'uid',
                                                params: { error: 'ambiguous' },
                                                message: 'encoding is ambiguous'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                        }
                        else {
                            validate16.errors = [
                                {
                                    instancePath: instancePath + '/elementID',
                                    schemaPath: '#/properties/elementID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid9 = _errs21 === errors;
                }
                else {
                    var valid9 = true;
                }
                if (valid9) {
                    if (data.name !== undefined) {
                        let data7 = data.name;
                        const _errs23 = errors;
                        if (errors === _errs23) {
                            if (typeof data7 === 'string') {
                                if (func2(data7) > 100) {
                                    validate16.errors = [
                                        {
                                            instancePath: instancePath + '/name',
                                            schemaPath: '#/properties/name/maxLength',
                                            keyword: 'maxLength',
                                            params: { limit: 100 },
                                            message: 'must NOT have more than 100 characters'
                                        }
                                    ];
                                    return false;
                                }
                                else {
                                    if (func2(data7) < 1) {
                                        validate16.errors = [
                                            {
                                                instancePath: instancePath + '/name',
                                                schemaPath: '#/properties/name/minLength',
                                                keyword: 'minLength',
                                                params: { limit: 1 },
                                                message: 'must NOT have fewer than 1 characters'
                                            }
                                        ];
                                        return false;
                                    }
                                }
                            }
                            else {
                                validate16.errors = [
                                    {
                                        instancePath: instancePath + '/name',
                                        schemaPath: '#/properties/name/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid9 = _errs23 === errors;
                    }
                    else {
                        var valid9 = true;
                    }
                    if (valid9) {
                        if (data.type !== undefined) {
                            let data8 = data.type;
                            const _errs25 = errors;
                            if (typeof data8 !== 'string') {
                                validate16.errors = [
                                    {
                                        instancePath: instancePath + '/type',
                                        schemaPath: '#/properties/type/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                            if (!(data8 === 'number' || data8 === 'string' || data8 === 'boolean')) {
                                validate16.errors = [
                                    {
                                        instancePath: instancePath + '/type',
                                        schemaPath: '#/properties/type/enum',
                                        keyword: 'enum',
                                        params: { allowedValues: schema35.properties.type.enum },
                                        message: 'must be equal to one of the allowed values'
                                    }
                                ];
                                return false;
                            }
                            var valid9 = _errs25 === errors;
                        }
                        else {
                            var valid9 = true;
                        }
                        if (valid9) {
                            if (data.timestamp !== undefined) {
                                let data9 = data.timestamp;
                                const _errs27 = errors;
                                if (errors === _errs27) {
                                    if (errors === _errs27) {
                                        if (typeof data9 === 'string') {
                                            if (!formats0.validate(data9)) {
                                                validate16.errors = [
                                                    {
                                                        instancePath: instancePath + '/timestamp',
                                                        schemaPath: '#/properties/timestamp/format',
                                                        keyword: 'format',
                                                        params: { format: 'date-time' },
                                                        message: 'must match format "' + 'date-time' + '"'
                                                    }
                                                ];
                                                return false;
                                            }
                                        }
                                        else {
                                            validate16.errors = [
                                                {
                                                    instancePath: instancePath + '/timestamp',
                                                    schemaPath: '#/properties/timestamp/type',
                                                    keyword: 'type',
                                                    params: { type: 'string' },
                                                    message: 'must be string'
                                                }
                                            ];
                                            return false;
                                        }
                                    }
                                }
                                var valid9 = _errs27 === errors;
                            }
                            else {
                                var valid9 = true;
                            }
                            if (valid9) {
                                if (data.reason !== undefined) {
                                    const _errs29 = errors;
                                    if (typeof data.reason !== 'string') {
                                        validate16.errors = [
                                            {
                                                instancePath: instancePath + '/reason',
                                                schemaPath: '#/properties/reason/type',
                                                keyword: 'type',
                                                params: { type: 'string' },
                                                message: 'must be string'
                                            }
                                        ];
                                        return false;
                                    }
                                    var valid9 = _errs29 === errors;
                                }
                                else {
                                    var valid9 = true;
                                }
                            }
                        }
                    }
                }
            }
        }
        else {
            validate16.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate16.errors = vErrors;
    return errors === 0;
}
export const periodColumnMetadataSchemaValidation = validate17;
function validate17(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:PeriodColumnMetadata" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.calendarID === undefined && (missing0 = 'calendarID')) ||
                (data.level === undefined && (missing0 = 'level'))) {
                validate17.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.calendarID !== undefined) {
                    let data0 = data.calendarID;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate17.errors = [
                                    {
                                        instancePath: instancePath + '/calendarID',
                                        schemaPath: '#/properties/calendarID/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate17.errors = [
                                {
                                    instancePath: instancePath + '/calendarID',
                                    schemaPath: '#/properties/calendarID/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.level !== undefined) {
                        let data1 = data.level;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate17.errors = [
                                        {
                                            instancePath: instancePath + '/level',
                                            schemaPath: '#/properties/level/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate17.errors = [
                                    {
                                        instancePath: instancePath + '/level',
                                        schemaPath: '#/properties/level/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate17.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate17.errors = vErrors;
    return errors === 0;
}
export const picklistColumnMetadataSchemaValidation = validate18;
function validate18(data, { instancePath = '', parentData, parentDataProperty, rootData = data } = {}) {
    /*# sourceURL="urn:wisepipe-common-data:PicklistColumnMetadata" */ let vErrors = null;
    let errors = 0;
    if (errors === 0) {
        if (data && typeof data == 'object' && !Array.isArray(data)) {
            let missing0;
            if ((data.table === undefined && (missing0 = 'table')) || (data.column === undefined && (missing0 = 'column'))) {
                validate18.errors = [
                    {
                        instancePath,
                        schemaPath: '#/required',
                        keyword: 'required',
                        params: { missingProperty: missing0 },
                        message: "must have required property '" + missing0 + "'"
                    }
                ];
                return false;
            }
            else {
                if (data.table !== undefined) {
                    let data0 = data.table;
                    const _errs1 = errors;
                    if (errors === _errs1) {
                        if (typeof data0 === 'string') {
                            if (func2(data0) < 1) {
                                validate18.errors = [
                                    {
                                        instancePath: instancePath + '/table',
                                        schemaPath: '#/properties/table/minLength',
                                        keyword: 'minLength',
                                        params: { limit: 1 },
                                        message: 'must NOT have fewer than 1 characters'
                                    }
                                ];
                                return false;
                            }
                        }
                        else {
                            validate18.errors = [
                                {
                                    instancePath: instancePath + '/table',
                                    schemaPath: '#/properties/table/type',
                                    keyword: 'type',
                                    params: { type: 'string' },
                                    message: 'must be string'
                                }
                            ];
                            return false;
                        }
                    }
                    var valid0 = _errs1 === errors;
                }
                else {
                    var valid0 = true;
                }
                if (valid0) {
                    if (data.column !== undefined) {
                        let data1 = data.column;
                        const _errs3 = errors;
                        if (errors === _errs3) {
                            if (typeof data1 === 'string') {
                                if (func2(data1) < 1) {
                                    validate18.errors = [
                                        {
                                            instancePath: instancePath + '/column',
                                            schemaPath: '#/properties/column/minLength',
                                            keyword: 'minLength',
                                            params: { limit: 1 },
                                            message: 'must NOT have fewer than 1 characters'
                                        }
                                    ];
                                    return false;
                                }
                            }
                            else {
                                validate18.errors = [
                                    {
                                        instancePath: instancePath + '/column',
                                        schemaPath: '#/properties/column/type',
                                        keyword: 'type',
                                        params: { type: 'string' },
                                        message: 'must be string'
                                    }
                                ];
                                return false;
                            }
                        }
                        var valid0 = _errs3 === errors;
                    }
                    else {
                        var valid0 = true;
                    }
                }
            }
        }
        else {
            validate18.errors = [
                { instancePath, schemaPath: '#/type', keyword: 'type', params: { type: 'object' }, message: 'must be object' }
            ];
            return false;
        }
    }
    validate18.errors = vErrors;
    return errors === 0;
}
//# sourceMappingURL=validations.generated.js.map